<template>
  <div class="gift-page">
    <div v-if="loading" class="loading">Loading...</div>
    
    <div v-else class="gift-content">
      <h1 class="gift-title">
        Keep this<br>
        Gift in your<br>
        <em>pocket.</em>
      </h1>
      
      <div class="qr-wrapper">
        <a :href="qrCodeData?.url || 'https://kewaar.com'" target="_blank" rel="noopener noreferrer">
          <img
            :src="qrCodeUrl"
            alt="QR Code"
            class="qr-code"
          />
        </a>
      </div>
      
      <p class="gift-subtitle">you'll need it...</p>
    </div>
    
    <button class="back-button" @click="goBack">
      ← Back to Exercises
    </button>
  </div>
</template>

<script>
import { getQRCode } from '@/services/firebase'

export default {
  name: 'GiftPage',
  data() {
    return {
      qrCodeData: null,
      loading: true
    }
  },
  computed: {
    qrCodeUrl() {
      const url = this.qrCodeData?.url || 'https://kewaar.com'
      const size = this.qrCodeData?.size || 250
      return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(url)}`
    }
  },
  async mounted() {
    try {
      this.qrCodeData = await getQRCode()
    } catch (error) {
      console.error('Failed to load QR code:', error)
    } finally {
      this.loading = false
    }
  },
  methods: {
    goBack() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.gift-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #14171F 0%, #1a1f2e 50%, #14171F 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  position: relative;
}

.loading {
  color: #888;
  font-size: 1.2rem;
}

.gift-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  max-width: 600px;
  width: 100%;
  animation: fadeIn 0.8s ease;
}

.gift-title {
  color: #fff;
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.1;
  margin: 0 0 60px 0;
  text-align: left;
}

.gift-title em {
  font-style: italic;
  font-weight: 400;
}

.qr-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 40px;
}

.qr-code {
  width: 250px;
  height: 250px;
  border-radius: 16px;
  background: #fff;
  padding: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.qr-code:hover {
  transform: scale(1.05);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
}

.gift-subtitle {
  color: #888;
  font-size: 1.3rem;
  font-style: italic;
  margin: 0;
  text-align: left;
}

.back-button {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  background: transparent;
  color: #888;
  border: 1px solid #3a3a4a;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s;
}

.back-button:hover {
  color: white;
  border-color: #888;
  background: rgba(255, 255, 255, 0.05);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .gift-title {
    font-size: 2.5rem;
    margin-bottom: 40px;
  }
  
  .qr-code {
    width: 200px;
    height: 200px;
  }
  
  .gift-subtitle {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .gift-title {
    font-size: 2rem;
  }
  
  .qr-code {
    width: 180px;
    height: 180px;
    padding: 12px;
  }
}
</style>
